import styled from "styled-components";
import { Dropdown, Menu } from "antd";
import { useApp } from "../../contexts";
import { languages } from "../../languages";
import { ArrowRightIcon } from "../Icons/ArrowRightIcon";
import { ArrowDownIcon } from "../Icons/ArrowDownIcon";

export const Header = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  position: relative;
`;
export const HeaderLeft = styled.div`
  @media screen and (max-width: 1024px) {
    & {
      flex: 1;
      display: flex;
      align-items: center;
      justify-content: center;
      height: 15px;
    }

    & svg {
      height: 15px;
    }
  }
`;
export const HeaderCenter = styled.div``;
export const HeaderRight = styled.div`
  @media screen and (max-width: 1024px) {
    position: absolute;
    right: 0;
    & svg,
    & {
      height: 24px;
    }
  }
`;

const HeaderLanguageContainer = styled(Dropdown)``;
const HeaderLanguageView = styled.div`
  display: flex;
  align-items: center;

  & span {
    display: inline-block;

    font-weight: 400;
    font-size: 16px;
    line-height: 25px;
    color: #707070;
  }
`;
const HeaderLanguageIcon = styled.div`
  height: 30px;
  display: block;

  & svg {
    width: 30px;
    height: 30px;
    display: block;
  }
`;
const HeaderLanguageSelectIcon = styled.div`
  height: 24px;
  display: flex;
  align-items: center;
  justify-content: center;

  & svg {
    width: 24px;
    height: 24px;
  }
`;
export const CurrencyContainer = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
`;

export const HeaderLanguage = (props) => {
  const { language, setLanguage, onSetLanguage } = useApp();
  const currentLanguage = languages.find((item) => item.id === language);
  return (
    <>
      <HeaderLanguageContainer
        overlayStyle={{
          boxShadow: "0px 0px 20px 0px rgba(0, 0, 0, 0.25)",
          borderRadius: 24,
          minWidth: 220,
          overflow: "hidden",
        }}
        trigger={["hover"]}
        placement={"bottomRight"}
        overlay={
          <Menu
            items={languages
              // .filter((item) => item.id !== language)
              .map((item, index) => {
                return {
                  key: index,
                  style: { padding: '0px 20px'},
                  className: `${index !== 0 ? 'border-t' : ''} border-solid border-[#F5F5F5] h-[55px]`,
                  label: (
                    <span
                      className="flex items-center justify-start gap-[18px] cursor-pointer"
                      onClick={() => onSetLanguage(item.id)}
                    >
                      <HeaderLanguageSelectIcon>
                        {item.icon()}
                      </HeaderLanguageSelectIcon>
                      {item.name}
                    </span>
                  ),
                };
              })}
          />
        }
      >
        <HeaderLanguageView>
          {props?.reverse ? (
            <>
              <HeaderLanguageIcon>{currentLanguage?.icon()}</HeaderLanguageIcon>
              <span
                style={{
                  color: "#666666",
                  cursor: "pointer",
                  textTransform: props?.withCode ? "uppercase" : "none",
                  fontWeight: props?.withCode ? "600" : "400",
                  paddingLeft: 12,
                  paddingRight: 6,
                }}
              >
                {props?.withName ? currentLanguage.name : ""}
                {props?.withCode ? currentLanguage.id : ""}
              </span>
              {props?.iconRight ? <ArrowRightIcon /> : <ArrowDownIcon />}
            </>
          ) : (
            <>
              <span
                style={{
                  color: "#666666",
                  cursor: "pointer",
                  textTransform: props?.withCode ? "uppercase" : "none",
                  fontWeight: props?.withCode ? "600" : "400",
                  paddingLeft: 12,
                  paddingRight: 6,
                }}
              >
                {props?.withName ? currentLanguage.name : ""}
                {props?.withCode ? currentLanguage.id : ""}
              </span>
              {props?.iconRight ? <ArrowRightIcon /> : <ArrowDownIcon />}
            </>
          )}
        </HeaderLanguageView>
      </HeaderLanguageContainer>
    </>
  );
};
export const HeaderCurrency = (props) => {
  const { currency, setCurrency, currenciesBase } = useApp();
  const onSetCurrency = (code) => {
    setCurrency(code);
  };

  const codeCurrencies = currenciesBase?.map((item) => item.code);

  return (
    <>
      <CurrencyContainer>
        {codeCurrencies.map((code, index) => (
          <div key={index}>
            <span
              style={{
                cursor: "pointer",
                color: currency === code ? "#666666" : "#000000",
              }}
              onClick={() => onSetCurrency(code)}
            >
              {code}
            </span>
            {index !== codeCurrencies?.length - 1 && (
              <span style={{ marginLeft: 6, marginRight: 6 }}>|</span>
            )}
          </div>
        ))}
      </CurrencyContainer>
    </>
  );
};
